const awsExportsDev = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:95ffa8f8-7052-4fe7-81b6-a667ad475206',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_yVEV4PCgq',
  aws_user_pools_web_client_id: '1t8m195ialp2l1mb0i5svmhq56',
  oauth: {
    domain: 'tolstoyappc81073b3-c81073b3-dev.auth.us-east-1.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://app.gotolstoy.com/',
    redirectSignOut: 'https://app.gotolstoy.com/',
    responseType: 'token',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint: 'https://2alqzqvqkvgvta2f5u5tt67gz4.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_user_files_s3_bucket: 'tolstoyprojects121629-dev',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

const awsExportsProd = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:7dfa2bb3-7b9e-4202-a98a-24ef8543cd31',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_UWIaOwb69',
  aws_user_pools_web_client_id: '3u51binjgo96g2ljan7aijoujl',
  oauth: {
    domain: 'tolstoyappc81073b3-c81073b3-prod.auth.us-east-1.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://app.gotolstoy.com/',
    redirectSignOut: 'https://app.gotolstoy.com/',
    responseType: 'token',
  },
  federationTarget: 'COGNITO_USER_AND_IDENTITY_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_appsync_graphqlEndpoint: 'https://myrtjlc7yvdi3mv6ft4ryiw7bm.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_cognito_login_mechanisms: ['EMAIL', 'GOOGLE'],
};

const awsExports = process.env.NODE_ENV === 'production' ? awsExportsProd : awsExportsDev;

export default awsExports;
